import React from 'react';
import { useDaresFilter } from 'root/src/client/web/record/DropEvent/DaresFilter/DaresFilterProvider';
import { ArrowDropDownSharp } from '@mui/icons-material';
import * as Accordion from '@radix-ui/react-accordion';
import { Checkbox } from 'root/src/client/v2/form/components/Checkbox';
import analyticsSendItem from 'root/src/client/logic/analytics/util/analyticsSendItem';
import { DROPS_ANALYTIC_EVENTS } from 'root/src/shared/drops/drops.analytics';
export const BattlePassTierFilter = React.memo(() => {
    const { state, options, onFilterChange } = useDaresFilter();
    if (!options.tiers.length) {
        return null;
    }
    const handleValueChange = (option) => {
        analyticsSendItem(DROPS_ANALYTIC_EVENTS.DROP_DARE_FILTERS, 'battle_pass_tier');
        if (state.tiers.includes(option)) {
            onFilterChange(Object.assign(Object.assign({}, state), { tiers: state.tiers.filter(item => item !== option) }));
        }
        else {
            onFilterChange(Object.assign(Object.assign({}, state), { tiers: [...state.tiers, option] }));
        }
    };
    return (<Accordion.Root className="AccordionRoot" type="single" collapsible defaultValue="tier">
			<Accordion.Item className="AccordionItem overflow-x-hidden" value="tier">
				<Accordion.AccordionTrigger className="uppercase flex py-2 justify-between group w-full">
					<span className="flex w-full">
						Battle pass tiers
					</span>
					<ArrowDropDownSharp className="!transition !duration-200 -rotate-90 group-data-[state=open]:rotate-0"/>
				</Accordion.AccordionTrigger>
				<Accordion.AccordionContent className="AccordionContent">
					<ul className="flex flex-col gap-2 p-4">
						{options.tiers.map((option) => {
            const isSelected = state.tiers.includes(option.value);
            return (<li key={option.value} className="flex flex-initial font-medium font-mono justify-between items-center gap-4">
									<label htmlFor={`tier-${option.value}`} className="flex select-none gap-3 items-center">
										{option.label}
									</label>
									<Checkbox id={`tier-${option.value}`} onCheckedChange={() => handleValueChange(option.value)} checked={isSelected}/>
								</li>);
        })}
					</ul>
				</Accordion.AccordionContent>
			</Accordion.Item>
		</Accordion.Root>);
});
